import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-settingsandpermissions',
    templateUrl: './settingsandpermissions.component.html',
    styleUrls: ['./settingsandpermissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingsAndPermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
